<template>
	<div>
		<div class="nav">
			<div class="brand">
				<img src="img/logo.jpg" alt="logo" class="logo" ondragstart="return false">
				Sunpacker
			</div>

			<h1>
				<div>
					single page applications with <span class="blue font-bold">React.js</span> & <span class="green font-bold">Vue.js</span>
				</div>
				<!-- <div>
					mobile applications with <span class="grey font-bold">React Native</span>
				</div> -->
			</h1>

			<div class="contacts-wrapper">
				<router-link :to="{ name: 'CV' }" class="cv">📄 Curriculum Vitae</router-link>
				<contacts />
			</div>
		</div>

		<div class="nav mobile">
			<div class="brand">
				<img src="img/logo.jpg" alt="logo" class="logo" ondragstart="return false">
				Sunpacker
			</div>

			<div class="contacts-wrapper">
				<router-link :to="{ name: 'CV' }" class="cv">📄 CV</router-link>
				<contacts />
			</div>
		</div>
	</div>
</template>

<script>
import Contacts from '@/components/Contacts'

export default {
	components: {
		Contacts
	}
}
</script>

<style lang="sass">
@import '../assets/css/smart-grid'
@import '../assets/css/_vars'

.nav
	display: flex
	flex-direction: column
	position: fixed
	top: 0
	left: 0
	padding: 1.5rem 2rem
	height: 100%
	background-color: $bgc1
	z-index: 999
	box-sizing: border-box
	.logo
		width: 3.5rem
		height: 3.5rem
		border-radius: 50%
		margin-right: 1.5rem
	.brand
		display: flex
		align-items: center
		margin-bottom: 1.5rem
		font-size: 3rem
		font-weight: 900
	h1
		font: normal .9rem $font1
		div
			line-height: 1.25rem
			margin-bottom: 1rem
	.contacts-wrapper
		margin-top: auto
		.cv
			display: block
			margin-bottom: 1rem
			color: $c2
			font: 400 1rem $font2
	&.mobile
		display: none
		flex-direction: row
		flex-wrap: wrap
		align-items: center
		width: 100%
		height: auto
		.logo
			width: 2.5rem
			height: 2.5rem
		.brand
			margin-bottom: 0
			font-size: 1.75rem
		.contacts-wrapper
			display: flex
			align-items: center
			margin-top: 0
			margin-left: auto
			.cv
				margin-bottom: 0
				margin-right: 1rem

@media screen and (max-width: $break_lg)
	.nav
		.logo
			width: 3rem
			height: 3rem
		.brand
			font-size: 2.25rem
		h1
			font-size: .75rem

@media screen and (max-width: $break_md)
	.nav
		display: none
		&.mobile
			display: flex
			padding: 1rem 1.5rem

@media screen and (max-width: $break_xs)
	.nav
		&.mobile
			.contacts-wrapper
				margin-top: .75rem
				margin-left: 0
				width: 100%
				.cv
					margin-right: auto
					font-size: .85rem
</style>
